import { IProduct } from '@interfaces';
import { categoryMapSingle } from '@components/common/products/utils';

import styles from '@components/common/products/product.styles';

export default function ProductSafety({ product }: { product?: IProduct }) {
    return (
        <div className={styles.safety} id="safety">
            <h3>{categoryMapSingle(product.category)}</h3>
            <h2>directions &amp; safety</h2>
            {!['barpacks', 'bars'].includes(product.category)
                ?
                <>
                    <p>
                        Shake well, then squeeze into a bowl or straight onto a spoon. Refrigerate
                        after opening and serve within 48 hours.
                    </p>
                    <p className="disclaimer">
                        <span>WARNING:</span> CAPS MAY BE A CHOKING HAZARD. KEEP CAPS
                        OUT OF REACH OF CHILDREN. DO NOT MICROWAVE.
                    </p>
                </>
                :
                <>
                    <p>
                        Your child may be ready for these bars when he or she stands with support,
                        self-feeds with fingers, and bites and chews a variety of textures.
                    </p>
                    <p className="disclaimer">
                        <span>WARNING:</span> THIS PRODUCT SHOULD ONLY BE FED TO SEATED, SUPERVISED.
                        CHILDREN WHO ARE ACCUSTOMED TO EATING SOLID FOODS.
                    </p>
                </>
            }
        </div>
    );
}
